import { ref } from "vue";
const DEFAULT_PAGE_SIZE = 10;
const DEFAULT_CURRENT_PAGE = 1;
function usePagination(fetchDataCb, option = { pageSize: DEFAULT_PAGE_SIZE, total: 0, currentPage: DEFAULT_CURRENT_PAGE }) {
  var _a, _b;
  const pageSize = ref((_a = option.pageSize) != null ? _a : DEFAULT_PAGE_SIZE);
  const currentPage = ref((_b = option.currentPage) != null ? _b : DEFAULT_CURRENT_PAGE);
  const total = ref(option.total);
  const setTotal = (all) => {
    total.value = all;
  };
  const setCurrentPage = (cur) => {
    currentPage.value = cur != null ? cur : DEFAULT_CURRENT_PAGE;
    fetchDataCb();
  };
  const currentPageChange = (page) => {
    currentPage.value = page;
    fetchDataCb();
  };
  const pageSizeChange = (size) => {
    pageSize.value = size;
    currentPage.value = DEFAULT_CURRENT_PAGE;
    fetchDataCb();
  };
  return {
    pageSize,
    currentPage,
    total,
    setTotal,
    setCurrentPage,
    currentPageChange,
    pageSizeChange
  };
}
export { usePagination };
